import React from 'react'

import { NewsSearchVisual } from '@/components/announcements/DiscoveryIntroModal/visuals'

export const NewsIntelligencePreview: React.FC = () => (
  <figure className="relative my-6 h-[194px] overflow-hidden rounded-xl border border-primary-200 bg-gradient-to-b from-accent-400/15 via-violet-500/[0.06] to-transparent dark:border-primary-800">
    <NewsSearchVisual />
    <figcaption className="sr-only">
      A natural-language news search returning relevant recent coverage with
      publication names, dates, and source links.
    </figcaption>
  </figure>
)

export default NewsIntelligencePreview
